<template>
  <div class="ranking-chart2" id="ranking">
    <span class="homepage-title">运营类型</span>
    <div class="chart-box">
      <div style="width:100%;height:100%;" id="ranking-chart2"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      HEIGHT: "",
      width: "",
      list: [
        { value: "0", name: "联营", type: "1" },
        { value: "0", name: "直营", type: "2" },
        { value: "0", name: "加盟", type: "3" },
        { value: "0", name: "托管", type: "4" },
      ],
      data: [],
      type: [],
      total: 0,
    };
  },
  mounted() {
    let o = document.getElementById("ranking");

    this.$nextTick(function () {
      if (this.$store.state.getChargersSortbyOperation != "") {
        this.getEchartData();
      }
      // this.getEchartData();
    });
  },
  destroyed() {
    window.onresize = null;
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getEchartData() {
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action: "getChargersSortbyOperation"
      // };
      // this.$api({
      //   method: "post",
      //   url: "/api.php/Overview/Index",
      //   data: params,
      //   transformRequest: [
      //     data => {
      //       let ret = "";
      //       for (let it in data) {
      //         ret +=
      //           encodeURIComponent(it) +
      //           "=" +
      //           encodeURIComponent(data[it]) +
      //           "&";
      //       }
      //       return ret;
      //     }
      //   ]
      // })
      //   .then(su => {
      let su = this.$store.state.getChargersSortbyOperation;
      if (su.data.code == 1) {
        // this.list = su.data.list;
        let list = [];
        list = su.data.list;
        for (let i in list) {
          // this.list[i].name = "联营";
          for (let j in this.list) {
            if (this.list[j].type == list[i].type) {
              this.list[j].value = list[i].value;
            }
            this.type.push({
              name: this.list[j].name,
              textStyle: { fontSize: "12px" },
            });
          }
        }
        this.drawChart(this.list);
      } else if (su.data.code == 0) {
        this.$message.error("数据库操作失败");
      } else if (su.data.code == 300) {
        localStorage.clear();
        this.$router.push("/login");
        // this.$message.error(su.data.message);
      } else if (su.data.code == 900) {
      } else {
        let list = [{ value: "0", type: "0" }];
        this.list = [{ value: "0", type: "0" }];
        for (let i in list) {
          for (let j in this.list) {
            if (this.list[j].type == list[i].type) {
              this.list[j].value = list[i].value;
            }
            this.type.push({
              name: this.list[j].name,
              textStyle: { fontSize: "12px" },
            });
          }
        }
        this.drawChart(this.list);
        this.$message.error(su.data.message);
      }
      // })
      // .catch(err => {});
    },
    drawChart(data) {
      for (let i in data) {
        this.total = this.total + Number(data[i].value);
      }
      let echart = echarts.init(document.getElementById("ranking-chart2"));
      var option = {
        tooltip: {
          textStyle: {
            align: "left",
          },
        },
        color: ["#F34133", "#EC631D", "#F7BC16", "#1BA838"],
        legend: {
          bottom: 8,
          left: "center",
          itemWidth: 10, // 图例图形宽度
          itemHeight: 10,
          itemGap: 10,
          // textStyle: { color: "#FFFDFE" },
          icon: "circle", //图例形状设置
          data: this.type,
          formatter: function (name) {
            let target;
            for (let i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                target = data[i].value;
              }
            }
            let arr = ["{b|" + name + "}"];
            return arr.join("\n");
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 10,
                color: "#FFFDFE",
              },
              b: {
                fontSize: 10,
                color: "#FFFDFE",
              },
            },
          },
        },
        graphic: [
          //饼图中间数字和文字显示
          {
            type: "text",
            // left: "36%",
            // top: "120px",
            left: "center",
            top: "43%",
            z: 2,
            zlevel: 100,
            style: {
              text: "产站数",
              fill: "#FFFFFD",
              font: "bold Microsoft YaHei",
              fontSize: 14,
            },
          },
          {
            type: "text",
            // left: "45%",
            // bottom: "100px",
            left: "center",
            top: "52%",
            z: 2,
            zlevel: 100,
            style: {
              text: this.total,
              // text: "",
              fill: "#5ec9ff",
              fontWeight: 700,
              fontSize: 26,
            },
          },
        ],
        series: [
          {
            name: "充电桩数",
            type: "pie",
            radius: ["40%", "55%"],
            center: ["50%", "50%"],
            label: {
              normal: {
                textStyle: {
                  color: "#5FC7FE",
                  fontSize: 12,
                },
              },
            },
            label: {
              //饼图线
              normal: {
                formatter: "{b}{c}\n",
                borderWidth: 20,
                borderRadius: 4,
                padding: [0, -20],
                rich: {
                  a: {
                    fontSize: 10,
                    lineHeight: 20,
                    align: "center",
                  },
                  //                         hr: {
                  //                             width: '100%',
                  //                             height: 4,
                  //                             align:'center'
                  //                         },
                  per: {
                    align: "center",
                    fontSize: 10,
                  },
                },
              },
            },
            data: data,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // formatter: "{b}  \n {c}" //标题换行，按照自己的格式进行配置
                },
                labelLine: {
                  show: true,
                  length: 8,
                  length2: 30,
                },
                borderWidth: 4, //每个扇形直接留有空隙
                borderColor: "#0C1E2A", //空隙颜色设置
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          },
        ],
      };
      echart.setOption(option);
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        setTimeout(function () {
          window.onresize = function () {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
  },
};
</script>

<style scoped lang="scss">
.ranking-chart2 {
  width: 100%;
  height: 100%;
  margin-bottom: 0px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  .homepage-title {
    // margin-left: 28px;
    color: #fffffd;
    left: 28%;
  }
  .chart-box {
    width: 100%;
    height: 90%;
    position: absolute;
    bottom: 0;
    // padding-top: 10%;
  }
}
@media screen and (max-width: 1500px) {
  .ranking-chart2 {
    .homepage-title {
      font-size: 12px;
      top: 7px;
      // left: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/displayScreen/rankingChart.vue